import { Link } from 'react-router-dom';
import { slugify } from '../../data/districtData';
import styles from './DevicesByDistrict.module.css';

function DevicesByDistrict({ districts, linkBasePath = '/district' }) {
  const max = Math.max(...districts.map((d) => d.count));

  return (
    <div className={styles.card}>
      <div className={styles.list}>
        {districts.map((d, i) => (
          <Link
            key={i}
            to={linkBasePath ? `${linkBasePath}/${d.zoneID != null ? d.zoneID : slugify(d.name)}` : '#'}
            className={styles.row}
          >
            <span className={styles.name}>{d.name}</span>
            <div className={styles.barTrack}>
              <div
                className={styles.barFill}
                style={{ width: `${(d.count / max) * 100}%` }}
              />
            </div>
            <span className={styles.count}>{(d.count ?? 0).toLocaleString()}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default DevicesByDistrict;
